// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import {
  ERR_ACCEPT_COMMERCIAL_AGREEMENT,
  SUC_ACCEPT_COMMERCIAL_AGREEMENT,
} from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useAcceptCommercialAgreementOffer = () => {
  const { submit } = useExerciseSubmission(
    CommercialAgreementOffer.CommercialAgreementOffer_Accept,
    SUC_ACCEPT_COMMERCIAL_AGREEMENT,
    ERR_ACCEPT_COMMERCIAL_AGREEMENT,
  );
  return submit;
};
